import script from "./ForestDetailYear.vue?vue&type=script&setup=true&lang=js"
export * from "./ForestDetailYear.vue?vue&type=script&setup=true&lang=js"

import "./ForestDetailYear.vue?vue&type=style&index=0&id=6b98b683&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b98b683"]])

export default __exports__